import React, { FC, useEffect, useState } from 'react'
import { isFulfilled } from '@reduxjs/toolkit'
import { FormikHelpers } from 'formik'

import Form from '../../components/Form'
import TextInput from '../../components/UI/Inputs/TextInput'
import SelectInput from '../../components/UI/Inputs/SelectInput'
import CustomButton from '../../components/UI/Buttons/CustomButton'
import { TCreateProjectFormValues } from '../../models/form'
import UploadImage from '../../components/UploadCropImage'

import { useDispatch, useSelector } from '../../store'
import { createProjectThunk, saveProjectSettings } from '../../store/project/thunks'
import { getTimezonesThunk } from '../../store/application/thunks'
import Checkbox from '../../components/UI/Inputs/Checkbox'
import { SETTING_NAME, TSaveProjectSettingsPayload } from '../../store/project/types'

interface CreateProjectStep1Props {
  goForward: (props: any) => void
  inProgress: boolean
}

const CreateProjectStep1: FC<CreateProjectStep1Props> = ({ inProgress, ...props }) => {
  const [image, setImage] = useState<any>(null)
  const [
    bypassExternalApprovalWhenInternalApproved,
    setBypassExternalApprovalWhenInternalApproved
  ] = useState<boolean>(false)
  const timezones = useSelector((state) =>
    state.app.timezones.map((zone: any) => ({
      label: zone.split('/').join(' - '),
      value: zone
    }))
  )
  const dispatch = useDispatch()

  const setUpForm = {
    initialValues: { name: '', timezone: '' },
    validation: 'project',
    onSubmit: async (
      values: TCreateProjectFormValues,
      actions: FormikHelpers<TCreateProjectFormValues>
    ) => {
      const data = new FormData()
      data.append('name', values.name)
      data.append('timezone', values.timezone)
      if (image) {
        data.append('image', image)
      }

      const createProjectResponse = await dispatch(createProjectThunk(data))
      const payload: TSaveProjectSettingsPayload = {
        project_id: createProjectResponse.payload.id,
        settings: [
          {
            name: SETTING_NAME.BYPASS_EXTERNAL_APPROVAL_WHEN_INTERNAL_APPROVED,
            value: bypassExternalApprovalWhenInternalApproved
          }
        ]
      }
      await dispatch(saveProjectSettings(payload))

      if (isFulfilled(createProjectResponse)) {
        props.goForward(createProjectResponse.payload.id)
      }
    }
  }

  useEffect(() => {
    const fetchTimezones = async () => await dispatch(getTimezonesThunk())
    fetchTimezones()
  }, [dispatch])

  return (
    <div className='agency-creation-step project-creation'>
      <div className='agency-creation-step__title'>Create a project</div>
      <div className='agency-creation-step__description'>Create new project</div>
      <UploadImage imageBorder='rounded-square' setImage={setImage} />
      <Form {...setUpForm}>
        <TextInput label='Project name' name='name' placeholder='Enter project name' />
        <SelectInput
          label='Project name'
          name='timezone'
          placeholder='Type to find your region'
          options={timezones}
        />
        <div className='upload-crop-image'>
          <Checkbox
            value={bypassExternalApprovalWhenInternalApproved}
            label="Allow post to be made live if External Approver doesn't get to it on time"
            onChange={({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) =>
              setBypassExternalApprovalWhenInternalApproved(checked)
            }
          />
        </div>

        <CustomButton inProgress={inProgress} button='primary' size='big' type='submit'>
          Submit
        </CustomButton>
      </Form>
    </div>
  )
}

export default CreateProjectStep1
